<template>
    <modal
        name="work-days-history-modal"
        @before-open="beforeOpen"
        @opened="opened"
        @closed="closed"
        class="modal--translation"
        v-cloak height="auto"
        :scrollable="true"
        :adaptive="true"
        :pivot-y="0.25"
    >
		<h5 class="modal-title" id="exampleModalLabel">{{ trans.history.title }}</h5>

        <div
            class="modal-loading-container"
            :class="{'loading-modal': loading}"
        >
            <div
                class="no-history-box"
                v-if="!loading && workDays.length == 0"
            >
                <p>{{ trans.history.no_history }}</p>
            </div>

            <table class="table table-striped">
                <tr v-for="workDay in workDays" :key="workDay.id">

                    <td>{{ workDay.created_at | datetime('DD. MM. YYYY, HH:mm') }}</td>

                    <td>
                        <template v-for="interval in workDay.intervals">
                            <span
                                v-if="interval.work_interval_type == workType"
                                class="badge badge-dark mt-1 mr-1"
                                :key="interval.id"
                            >
                                {{ interval.from | datetime('HH:mm') }} - {{ interval.to | datetime('HH:mm') }}
                            </span>

                            <span
                                v-else
                                class="badge badge-holiday mt-1 mr-1"
                                :key="interval.id"
                            >
                                {{ translateWorkDayValue(interval.work_interval_type) }}
                            </span>
                        </template>

                        <span
                            v-if="workDay.intervals_sum"
                            class="badge badge-success mt-1"
                        >
                            <strong>{{ workDay.intervals_sum | time('HH:mm') }}&nbsp;{{ trans.hours }}</strong>
                        </span>
                    </td>

                    <td>
                        <button
                            type="button"
                            class="btn btn-sm btn-warning"
                            @click="revertDay(workDay)"
                        >
                            <i class="fal fa-reply"></i>
                        </button>
                    </td>

                </tr>
            </table>
    	</div>

        <div class="text-center" style="margin-top: 30px;">
            <button class="btn btn-primary" type="button" @click="closeModal()">
                <strong>{{ trans.closeBtn }}</strong>
            </button>
        </div>
    </modal>
</template>

<script>
    const userLanguage = document.documentElement.lang;

    export default {
        name: 'work-days-history-modal',
        data: function() {
            return {
                loading: false,
                url: null,
                date: null,
                workDays: []
            }
        },

        props: {
            'baseUrl': {
                type: String
            },
            'revertBaseUrl': {
                type: String
            },
            'trans': {
                type: Object
            },
            'transWorkDay': {
                type: Object
            },
            'workType': {
                type: String
            }
        },

        created() {

        },

        methods: {
            beforeOpen (event) {
                const day = event.params.day;

                this.date = moment(day.date);
                this.url = this.baseUrl+"/"+this.date.format('YYYY')+"/"+this.date.format('MM')+"/"+this.date.format('DD');
            },

            opened() {
                this.fetchDays();
            },

            closed() {
                this.workDays = [];
            },
            fetchDays() {
                const _this = this;
                this.loading = true;

                axios.get(this.url).then(function (response) {
                    _this.workDays = response.data;
                    _this.loading = false;
                }, function (error) {
                    _this.loading = false;
                });
            },

            revertDay(workDay) {
                const _this = this;
                const url = this.revertBaseUrl+"/"+workDay.id;

                this.loading = true;

                axios.post(url).then(function (response) {
                    _this.$emit('refreshattendance');
                    _this.$emit('refreshcalendar');
                    _this.$emit('refreshworkedholidays');
                    _this.$emit('refreshbalances');

                    _this.loading = false;
                    _this.closeModal();
                }, function (error) {
                    _this.loading = false;
                });
            },

            closeModal() {
                this.$modal.hide('work-days-history-modal');
            },

            translateWorkDayValue(type) {
                var shortVal = "";
                var val = "";

                for (const [key, value] of Object.entries(this.transWorkDay)) {
                    if(type + "_short" == key) shortVal = value;
                    if(type == key) val = value;
                }

                return (shortVal ? shortVal : (val ? val : '?'));
            }

        },
        filters: {
            date: function date(date) {
                var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';

                var date = (0, moment)(date);
                return date.isValid() ? date.format(format) : "";
            },
            datetime: function datetime(_datetime) {
                var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';

                var date = (0, moment)(_datetime);
                return date.isValid() ? date.format(format) : "";
            },
            time: function time(_time) {
                var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'HH:mm:ss';

                var date = (0, moment)('2000-01-01 ' + _time);
                return date.isValid() ? date.format(format) : "";
            },
            floatToTime: function floatToTime(number) {
                 var date = new Date(number * 3600 /* sec per hr */
                           * 1000 /* msec per sec */);
                return ('0' + date.getUTCHours()  ).slice(-2) + ':' +
                        ('0' + date.getUTCMinutes()).slice(-2);
            }
        },
    }
</script>


<style lang="scss">
    $puff: url('data:image/svg+xml;utf8,<svg width="44" height="44" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg" stroke="#4273FA"><g fill="none" fill-rule="evenodd" stroke-width="2"><circle cx="22" cy="22" r="1"><animate attributeName="r" begin="0s" dur="1.8s" values="1; 20" calcMode="spline" keyTimes="0; 1" keySplines="0.165, 0.84, 0.44, 1" repeatCount="indefinite"/><animate attributeName="stroke-opacity" begin="0s" dur="1.8s" values="1; 0" calcMode="spline" keyTimes="0; 1" keySplines="0.3, 0.61, 0.355, 1" repeatCount="indefinite"/></circle><circle cx="22" cy="22" r="1"><animate attributeName="r" begin="-0.9s" dur="1.8s" values="1; 20" calcMode="spline" keyTimes="0; 1" keySplines="0.165, 0.84, 0.44, 1" repeatCount="indefinite"/><animate attributeName="stroke-opacity" begin="-0.9s" dur="1.8s" values="1; 0" calcMode="spline" keyTimes="0; 1" keySplines="0.3, 0.61, 0.355, 1" repeatCount="indefinite"/></circle></g></svg>');

    .loading-modal:before {
      content: $puff;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(255, 255, 255, 0.75);
      z-index: 3;
    }

    .modal-loading-container {
        position: relative;
        min-height: 300px;
    }
    .no-history-box {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 300px;

        p {
            font-size: 18px;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/attendance/modals/WorkDaysHistoryModal.vue